<template>
  <div>
    <v-dialog
        :value="dialog"
        class="overflow-hidden"
        @input="setDialogAction(!dialog)"
        :width="$vuetify.breakpoint.mdAndDown ? '95%' : '656px'"
        content-class="rounded-xl"
    >
<!--      <v-card v-if="loading" class="d-flex flex-column justify-center align-center rounded-xl overflow-hidden">-->
<!--        <v-progress-circular-->
<!--          :size="55"-->
<!--          :width="7"-->
<!--          :color="$store.state.achievement.side_color"-->
<!--          indeterminate-->
<!--        ></v-progress-circular>-->
<!--      </v-card>-->

      <v-card class="rounded-xl overflow-hidden transition-ease-in-out" style="z-index: 25">
        <the-form-filling-achievements/>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import Trophy from "../Icons/Trophy";

const TheFormFillingAchievements = () => import("../Forms/FormAchievement/TheFormFillingAchievements.vue");


export default {
  name: "FormAchievementDialog",
  components: {
    TheFormFillingAchievements,
    Trophy,
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    ...mapState({
      dialog: state => state.achievement.dialog,
      editMode: state => state.achievement.editModeForm,
    }),

  },

  methods: {
    ...mapActions({
      setDialogAction: 'achievement/setDialogAction',
    }),
  }
}
</script>

<style scoped>

</style>